module.exports = __webpack_public_path__ + "static/media/fondo_maquillaje.89b165d7.jpg";